import React, { useState, useEffect, useRef } from "react";
import AppHeader from "./pages/AppHeader";
import Home from "./pages/Home";
import HomeInventory from "./pages/HomeInventory";
import ProjInv from "./pages/ProjInv";
import SlipCreation from "./pages/SlipCreation/SlipCreation";
import SlipInventory from "./pages/SlipInventory/SlipInventory";
import AuditInventory from "./pages/AuditInventory/AuditInventory";
import { UserMgntFile } from "./pages/UserMgnt/UserMgntFile";
import ModifyInventory from "./pages/ModifyInventory/ModifyInventory";
import ViewAuditInventory from "./pages/ViewAuditInventory/ViewAuditInventory";
import UpdateSlipInventory from "././pages/UpdateSlipInventory/UpdateSlipInventory";
import MRPController from "././pages/Reports/ReportInventory/MRPController";
import SummaryReport from "./pages/Reports/ReportInventory/SummaryReport";
import LocationReport from "./pages/Reports/ReportInventory/LocationReport";
import TableEdit from "./pages/Reports/ReportInventory/Table";
import UserManagement from "./pages/UserManagement/UserManagement";
import Summary from "./pages/SlipSummery/SlipSummary";
import { HistoricalData } from "./pages/HistoryData/HistoricalData";
import Reports from "./pages/Reports/Reports";
import WorkCenterLossesForm from "./pages/WorkCenterLossesForm/WorkCenterLossesForm";
import WorkCenterSummary from "./pages/WorkCenterLossesForm/WorkCenterSummary";
import UploadSapData from "./pages/UploadSapData/UploadSapData";
import SapDataDetails from "./pages/UploadSapData/SapDataDetails";
import SharedComponents from "../src/SharedComponents/SharedComponents";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./common/styles/appbar.css";
import "./common/styles/common.css";
import "./common/styles/drawer.css";
import "./common/styles/component.css";
import "./common/styles/mobile.css";
import "./common/styles/fonts.css";
import IdleTimer from "react-idle-timer";
import UnauthorizedAccess from "./pages/UnauthorizedAccess";
import { createBrowserHistory } from "history";
import Bulk from "./pages/BulkUploadInventory/Bulk";
import SapUpload from "./pages/SapUploadInventory/SapUpload";
import BulkSlipCreation from "./pages/BulkSlipCreation/BulkSlipCreation";
import {
  storeUserDetailsAction,
  saveUIDAction,
  saveBearerTokenAction,
  AppIDAction,
} from "../../ClientApp/src/ReduxStore/Actions/actions";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Error from "./components/Error404";

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

const App = () => {
  const dispatch = useDispatch();
  const [employee, setEmployee] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUserRoleID, setCurrentUserRoleID] = useState("");
  const [employeeFirstName, setEmployeeFirstName] = useState("");
  const [employeeLastName, setEmployeeLastName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [phyInvemployee, setPhyInvEmployee] = useState([]);
  const [phyInvcurrentUserRoleID, setPhyInvCurrentUserRoleID] = useState("");
  const [phyInvemployeeFirstName, setPhyInvEmployeeFirstName] = useState("");
  const [phyInvemployeeLastName, setPhyInvEmployeeLastName] = useState("");
  const [phyInvemployeeId, setPhyInvEmployeeId] = useState("");
  const [eperFormanceData,setEperFormanceData] = useState([]);
  const [physicalData, setPhysicalData]= useState([]);

  const idleTimer = useRef(null); //Eperformance

  useEffect(() => {
    const fetchData = async () => {
      const apiEperformanceUser = await fetch("Login/getUser");
      const apiPhyInvUser = await fetch("Login/getPhyInvUser");
      Promise.all([apiEperformanceUser, apiPhyInvUser])
        .then(([res1, res2]) => {
          // Check if both responses are ok
          if (!res1.ok || !res2.ok) {
            throw new Error("Network response was not ok");
          }
          return Promise.all([res1.json(), res2.json()]);
        })
        .then(async ([Eperformance, physicalInventory]) => {
          // Now physicalInventory and Eperformance are in JSON format
          // console.log('phyInv',physicalInventory, Eperformance,'Eperformance');
          if (
            physicalInventory.result.response ||
            Eperformance.result.response
          ) {
            if (physicalInventory != null && Eperformance !== null) {
              const id = localStorage.getItem("ApplicationId");
              // console.log(id,'eperFormanceData');

              //console.log('app.js')
              if (physicalInventory.result.response) {
                getPhyInvLandingmenues(
                  physicalInventory.result.response.applicationId,
                  physicalInventory.result.tokenString,
                  physicalInventory.result.response.emailId,
                  physicalInventory.result.uid,
                  physicalInventory.result.response.roleName,
                  physicalInventory.result.response.gid,
                  physicalInventory.result.response.roleId
                );

                setEmployee(physicalInventory.result);
                setCurrentUserRoleID(physicalInventory.result.response.roleId);
                setEmployeeFirstName(
                  physicalInventory.result.response.firstName
                );
                setEmployeeLastName(physicalInventory.result.response.lastName);
                setEmployeeId(physicalInventory.result.response.employeeId);

              
              }
              if (Eperformance.result.response) {
                getEperformancesubmenu(
                  Eperformance.result.response.applicationId,
                  Eperformance.result.tokenString,
                  Eperformance.result.response.emailId,
                  Eperformance.result.uid,
                  Eperformance.result.response.roleName,
                  Eperformance.result.response.gid,
                  Eperformance.result.response.roleId
                );

                setPhyInvEmployee(Eperformance.result);
                setPhyInvCurrentUserRoleID(Eperformance.result.response.roleId);
                setPhyInvEmployeeFirstName(
                  Eperformance.result.response.firstName
                );
                setPhyInvEmployeeLastName(Eperformance.result.response.lastName);
                setPhyInvEmployeeId(Eperformance.result.response.employeeId);

                
              }
              if (id == null || id == 1) {
                if (Eperformance.result.response) {
                  localStorage.setItem("uid", Eperformance.result.uid);
                  localStorage.setItem(
                    "bearer",
                    Eperformance.result.tokenString
                  );
                  localStorage.setItem(
                    "userdetails",
                    JSON.stringify(Eperformance.result.response)
                  );
                  localStorage.setItem(
                    "applicationId",
                    Eperformance.result.response.applicationId
                  );
                  dispatch(saveUIDAction(Eperformance.result.uid));
                  dispatch(
                    saveBearerTokenAction(Eperformance.result.tokenString)
                  );
                  dispatch(
                    storeUserDetailsAction(Eperformance.result.response)
                  );
                  dispatch(
                    AppIDAction(Eperformance.result.response.applicationId)
                  );
                }
              } else if (
                Eperformance.result.response.applicationId == 2 &&
                id == 2
              ) {
                dispatch(saveUIDAction(Eperformance.result.uid));
                dispatch(
                  saveBearerTokenAction(Eperformance.result.tokenString)
                );
                dispatch(storeUserDetailsAction(Eperformance.result.response));
                dispatch(
                  AppIDAction(Eperformance.result.response.applicationId)
                );
              } else if (
                physicalInventory.result.response.applicationId == 3 &&
                id == 3
              ) {
                dispatch(saveUIDAction(physicalInventory.result.uid));
                dispatch(
                  saveBearerTokenAction(physicalInventory.result.tokenString)
                );
                dispatch(
                  storeUserDetailsAction(physicalInventory.result.response)
                );
                dispatch(
                  AppIDAction(physicalInventory.result.response.applicationId)
                );
              }
            } else if (physicalInventory != null) {
              setEmployee(physicalInventory.result.response);
              setCurrentUserRoleID(physicalInventory.result.response.roleId);
              setEmployeeFirstName(physicalInventory.result.response.firstName);
              setEmployeeLastName(physicalInventory.result.response.lastName);
              setEmployeeId(physicalInventory.result.response.employeeId);
            } else if (Eperformance !== null) {
              setPhyInvEmployee(Eperformance.result.response);
              setPhyInvCurrentUserRoleID(Eperformance.result.response.roleId);
              setPhyInvEmployeeFirstName(
                Eperformance.result.response.firstName
              );
              setPhyInvEmployeeLastName(Eperformance.result.response.lastName);
              setPhyInvEmployeeId(Eperformance.result.response.employeeId);
            }
          } else {
            setLoading(false);
            setEmployee(null);
            setPhyInvEmployee(null);
          }
      
         
         // setLoading(false);
          
          //setEmployee(null);
          // setPhyInvEmployee(null);

          // Further processing can be done here
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    };

    fetchData();
  }, []);

  const handleOnIdle = () => {
    //console.log("user is idle", new Date());
    localStorage.clear();
    window.location.href = "Login/logout";
  };

  let eperFormancePages = [];

  function getEperformancesubmenu(
    appid,
    tokenString,
    emailId,
    uid,
    roleName,
    gid,
    roleId
  ) {
    const appID = appid;
    const headers = {
      Authorization: "Bearer " + tokenString,
      UserEmail: emailId,
      userId: uid,
      RoleName: roleName,
      Gid: gid,
      Roleid: roleId,
      //AzureToken: token,
    };
    return fetch("MasterDetails/GetLandingMenuData?appid=" + appID, {
      headers: headers,
    })
      .then((response) =>  response.json())
      .then((data) => {
        if(eperFormancePages.length ==0){

        
      // eperFormancePages = data.result;

        for (let i = 0; i < data.result.length; i++) {
         if (data.result[i].menuName != 'Home' && data.result[i].menuName != '' ){
            let a  =
          data.result[i].menuLink.split("/");
          data.result[i].menuName = a[1];
          eperFormancePages.push(data.result[i])
          }
        }
        setEperFormanceData(eperFormancePages);
        
        //console.log("eperformamce pages", eperFormancePages);
        setLoading(false);
      }

     
    // 
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }

  let phySicalPages = [];
  function getPhyInvLandingmenues(
    appid,
    tokenString,
    emailId,
    uid,
    roleName,
    gid,
    roleId
  ) {
    const appID = appid;
    const headers = {
      Authorization: "Bearer " + tokenString,
      UserEmail: emailId,
      userId: uid,
      RoleName: roleName,
      Gid: gid,
      Roleid: roleId,
      //AzureToken: token,
    };
    return fetch("MasterDetails/GetLandingMenuData?appid=" + appID, {
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        //phySicalPages = data.result;

    if(phySicalPages.length == 0){
        for (let i = 0; i < data.result.length; i++) {
          if (data.result[i].menuName != 'Home' && data.result[i].menuName != ''){
            let b  =
          data.result[i].menuLink.split("/");
          data.result[i].menuName = b[1];
          phySicalPages.push(data.result[i])
          }
        }
        setPhysicalData(phySicalPages);
        //console.log("physical pages", phySicalPages);
        setLoading(false);
      }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }

  const pageComponents = {
    SlipCreation: <SlipCreation loginuser = {phyInvemployee} />,
    Summary:<Summary/>,
    WorkCenterLossesForm:<WorkCenterLossesForm loginuser={phyInvemployee}/>,
    WorkCenterSummary:<WorkCenterSummary/>,
    Reports:<Reports/>,
    SapDataDetails:<SapDataDetails loginuser={phyInvemployee}/>,
    UserManagement:<UserManagement loginuser={phyInvemployee}/>,
    SlipInventory:<SlipInventory loginuser={employee}/>,
    ModifyInventory:<ModifyInventory loginuser={employee}/>,
    BulkSlipCreation:<BulkSlipCreation loginuser={employee}/>,
    SummaryReport:<SummaryReport loginuser={employee}/>,
    LocationReport:<LocationReport loginuser={employee}/>,
    MRPController:<MRPController loginuser={employee}/>,
    SapUpload:<SapUpload loginuser={employee}/>,
    HistoricalData:<HistoricalData loginuser={employee}/>,
    AuditInventory:<AuditInventory loginuser={employee}/>,
    ViewAuditInventory:<ViewAuditInventory loginuser={employee}/>,
    UserMgntFile:<UserMgntFile loginuser={employee}/>
    };


  const renderUserDetails = () => {


    if (
      (employee !== "" && employee !== null && employee !== undefined && employee.response) ||
      (phyInvemployee !== "" &&
        phyInvemployee !== null &&
        phyInvemployee !== undefined && phyInvemployee.response)
    ) {
      let routes = [];
    // if user have both the acesss physical and eperformance then they can able to see physical and eper pages
      if (
        (employee !== "" &&
        employee !== null &&
        employee !== undefined && employee.response) &&
        (phyInvemployee !== "" &&
        phyInvemployee !== null &&
        phyInvemployee !== undefined && phyInvemployee.response)
      ) {
        // eperformance pages $ physical pages
        routes = (
          <Switch>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              render={(props) => (
                <ProjInv
                  firstName={employeeFirstName}
                  lastName={employeeLastName}
                  physicalInventory={employee}
                  Eperformance={phyInvemployee}
                />
              )}
            />
             <Route
              exact
              path={`${process.env.PUBLIC_URL}/HomeInventory`}
              render={(props) => (
                <HomeInventory
                  firstName={employeeFirstName}
                  loginuser={employee}
                />
              )}
            />

            <Route
              exact
              path={`${process.env.PUBLIC_URL}/Home`}
              render={(props) => (
                <Home
                  firstName={phyInvemployeeFirstName}
                  lastName={phyInvemployeeLastName}
                />
              )}
            />

            {eperFormanceData.map((item) => (
              <Route
              key={item.menuName}
              path={item.menuLink}
              render={() => pageComponents[item.menuName]  }
              />
            ))}

            {physicalData.map((item) => (
              <Route
              key={item.menuName}
              path={item.menuLink}
              render={() => pageComponents[item.menuName]  }
              />

              
            ))}

           


            {/* this page will be visible for the physical for all the roles accept user */}
           { Number(currentUserRoleID) != 1 &&
            <Route
                exact
                path={`${process.env.PUBLIC_URL}/TableEdit`}
                render={(props) => <TableEdit loginuser={employee} />}
              />
           }

            <Route render={() => <Error />} />
          </Switch>
        );
     
      } 
          // if user have only physical then they can able to see physical pages
      else if (
        employee !== "" &&
        employee !== null &&
        employee !== undefined && employee.response
      ) {
        routes = (
          <Switch>

            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              render={(props) => (
                <ProjInv
                  firstName={
                    employeeFirstName
                      ? employeeFirstName
                      : phyInvemployeeFirstName
                  }
                  lastName={employeeLastName?employeeLastName:phyInvemployeeLastName}
                  physicalInventory={employee}
                  Eperformance={phyInvemployee}
                />
              )}
            />
             <Route
              exact
              path={`${process.env.PUBLIC_URL}/HomeInventory`}
              render={(props) => (
                <HomeInventory
                  firstName={employeeFirstName}
                  loginuser={employee}
                />
              )}
            />
             {physicalData.map((item) => (
              <Route
              key={item.menuName}
              path={item.menuLink}
              render={() => pageComponents[item.menuName]}
              />
            ))}
        

           

              {/* this page will be visible for the physical for all the roles accept user */}
           { Number(currentUserRoleID) != 1 &&
            <Route
                exact
                path={`${process.env.PUBLIC_URL}/TableEdit`}
                render={(props) => <TableEdit loginuser={employee} />}
              />
           }
           
            <Route render={() => <Error />} />
          </Switch>
        );
      }
      // if user have only eperformance then they can able to see eperformance pages
       else if (
        phyInvemployee !== "" &&
        phyInvemployee !== null &&
        phyInvemployee !== undefined && phyInvemployee.response
      ) {
        // eperformance pages
        routes = (
          <Switch>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              render={(props) => (
                <ProjInv
                  // firstName={
                  //   employeeFirstName
                  //     ? employeeFirstName
                  //     : phyInvemployeeFirstName
                  // }
                  firstName={
                    phyInvemployeeFirstName
                      ? phyInvemployeeFirstName
                      : employeeFirstName
                  }
                  lastName={employeeLastName?employeeLastName:phyInvemployeeLastName}
                  physicalInventory={employee}
                  Eperformance={phyInvemployee}
                />
              )}
            />
             <Route
              exact
              path={`${process.env.PUBLIC_URL}/Home`}
              render={(props) => (
                <Home
                  firstName={phyInvemployeeFirstName}
                  lastName={phyInvemployeeLastName}
                />
              )}
            />
          
           
              {eperFormanceData.map((item) => (
              <Route
              key={item.menuName}
              path={item.menuLink}
              render={() => pageComponents[item.menuName]  }
            />
          ))}
            
          <Route render={() => <Error />} />
          </Switch>
        );
      }

     

      return (
        <BrowserRouter>
          <div className="d-flex">
            <AppHeader
              role={currentUserRoleID}
              pyinvrole={phyInvcurrentUserRoleID}
            />
            <main className="nomination_main">{routes}</main>
          </div>
        </BrowserRouter>
      );
    } 

    // if user have none of the acesss it will goes to the else part and they are not authoreised to view any of the pages
    else {
      return (
        <BrowserRouter>
          <React.Fragment>
            <main className="nomination_main">
              <UnauthorizedAccess />
            </main>
          </React.Fragment>
        </BrowserRouter>
      );
    }
  };

  return (
    <div>
      <IdleTimer
        ref={idleTimer}
        timeout={1000 * 600 * 1}
        onIdle={handleOnIdle}
        debounce={250}
      />
      {loading?  (
        <p>
          <em>Loading...</em>
        </p>
      ) : (
        renderUserDetails(
          employee,
          currentUserRoleID,
          employeeFirstName,
          employeeLastName,
          employeeId,
          phyInvemployee,
          phyInvcurrentUserRoleID,
          phyInvemployeeFirstName,
          phyInvemployeeId
        )
      )}
    </div>
  );
};

export default App;
